// extracted by mini-css-extract-plugin
export default {"osfSectionWrapper":"index-module--osfSectionWrapper--6a271","osfContainer":"index-module--osfContainer--13192"};